const Pagination = ({ pageSize, currentPage, totalData, onPageChange, onClearHistory }) => {
    const totalPages = Math.ceil(totalData / pageSize);
    return (
      <div>
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Prev
        </button>
        &nbsp;&nbsp;<span>
          {currentPage} of {totalPages}
        </span>&nbsp;&nbsp;
        <button
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </button>&nbsp;&nbsp;
        <button
          onClick={() => onClearHistory()}
        >
          Remove all history
        </button>
      </div>
    );
  };
  
  export default Pagination;